import { lazy, Suspense } from 'react'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import './index.css'
import { AuthProvider } from './features/auth/AuthProvider'
import { OfflineProvider } from './services/offline/OfflineProvider'
import { LoginPage } from './features/auth/LoginPage'
import { ForgotPasswordPage } from './features/auth/ForgotPasswordPage'
import { ResetPasswordPage } from './features/auth/ResetPasswordPage'
import { RequirePermission, RequireSession, RoleHome } from './features/auth/ProtectedRoutes'
import { EnvironmentBadge } from './components/layout/EnvironmentBadge'

const CompraDetailPage = lazy(() => import('./features/compras/pages/CompraDetailPage').then((module) => ({ default: module.CompraDetailPage })))
const ComprasListPage = lazy(() => import('./features/compras/pages/ComprasListPage').then((module) => ({ default: module.ComprasListPage })))
const RequisicaoDetailPage = lazy(() => import('./features/requisicoes/pages/RequisicaoDetailPage').then((module) => ({ default: module.RequisicaoDetailPage })))
const RequisicaoFormPage = lazy(() => import('./features/requisicoes/pages/RequisicaoFormPage').then((module) => ({ default: module.RequisicaoFormPage })))
const RequisicoesListPage = lazy(() => import('./features/requisicoes/pages/RequisicoesListPage').then((module) => ({ default: module.RequisicoesListPage })))
const MyAccountPage = lazy(() => import('./features/auth/MyAccountPage').then((module) => ({ default: module.MyAccountPage })))
const AdminDashboardPage = lazy(() => import('./features/admin/pages/AdminDashboardPage').then((module) => ({ default: module.AdminDashboardPage })))
const AdminUsersPage = lazy(() => import('./features/admin/pages/AdminUsersPage').then((module) => ({ default: module.AdminUsersPage })))
const AdminCatalogPage = lazy(() => import('./features/admin/pages/AdminCatalogPage').then((module) => ({ default: module.AdminCatalogPage })))
const AdminItemRequestsPage = lazy(() => import('./features/admin/pages/AdminItemRequestsPage').then((module) => ({ default: module.AdminItemRequestsPage })))
const AdminAuditPage = lazy(() => import('./features/admin/pages/AdminAuditPage').then((module) => ({ default: module.AdminAuditPage })))

export default function App() {
  return (
    <>
      <EnvironmentBadge />
      <BrowserRouter>
        <AuthProvider>
          <OfflineProvider>
            <Suspense fallback={<main className="center-state" role="status">Carregando área de trabalho...</main>}>
            <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/esqueci-senha" element={<ForgotPasswordPage />} />
            <Route path="/redefinir-senha" element={<ResetPasswordPage />} />
            <Route element={<RequireSession />}>
              <Route path="/app" element={<RoleHome />} />
              <Route path="/app/minha-conta" element={<MyAccountPage />} />
              <Route element={<RequirePermission anyOf={['requisitions.view_own', 'requisitions.view_all']} />}>
                <Route path="/app/requisicoes" element={<RequisicoesListPage />} />
                <Route path="/app/requisicoes/:id" element={<RequisicaoDetailPage />} />
              </Route>
              <Route element={<RequirePermission anyOf={['requisitions.create']} />}>
                <Route path="/app/requisicoes/nova" element={<RequisicaoFormPage />} />
              </Route>
              <Route element={<RequirePermission anyOf={['requisitions.edit_own']} />}>
                <Route path="/app/requisicoes/:id/editar" element={<RequisicaoFormPage />} />
              </Route>
              <Route element={<RequirePermission anyOf={['purchases.view']} />}>
                <Route path="/app/compras" element={<ComprasListPage />} />
                <Route path="/app/compras/:id" element={<CompraDetailPage />} />
              </Route>
              <Route element={<RequirePermission anyOf={['users.view', 'catalog.manage', 'item_requests.manage', 'audit.view']} />}>
                <Route path="/app/admin" element={<AdminDashboardPage />} />
              </Route>
              <Route element={<RequirePermission anyOf={['users.view']} />}>
                <Route path="/app/admin/usuarios" element={<AdminUsersPage />} />
              </Route>
              <Route element={<RequirePermission anyOf={['catalog.manage']} />}>
                <Route path="/app/admin/itens" element={<AdminCatalogPage />} />
              </Route>
              <Route element={<RequirePermission anyOf={['item_requests.manage']} />}>
                <Route path="/app/admin/itens/solicitacoes" element={<AdminItemRequestsPage />} />
              </Route>
              <Route element={<RequirePermission anyOf={['audit.view']} />}>
                <Route path="/app/admin/auditoria" element={<AdminAuditPage />} />
              </Route>
            </Route>
            <Route path="/" element={<Navigate replace to="/app" />} />
            <Route path="*" element={<Navigate replace to="/app" />} />
            </Routes>
            </Suspense>
          </OfflineProvider>
        </AuthProvider>
      </BrowserRouter>
    </>
  )
}
